import React from 'react';
import {BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {getSummary} from '../CreateBuilder/BuilderSourceDestination/builderNaming';
import {BuilderTransferSourceForm} from './BuilderTransferSourceForm';
import {getCurrencyFloat} from '../../../utils/currencyFormatter';

interface TransferSourceSubplanProps {
  subPlan: BuilderPot_dentistChildren;
  isSelected: boolean;
  handleChange: () => void;
}

export const TransferSourceSubplan: React.FC<TransferSourceSubplanProps> = ({
  subPlan,
  isSelected,
  handleChange,
}) => {
  const formikKeyPrefix = `transfer.transferSources.${subPlan.id}`;

  return (
    <PlanRow
      id={subPlan.id}
      reccId={subPlan.originalOvrId ?? null}
      isSelected={isSelected}
      isSubplan
    >
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent={false}
        flat
        compact
        validationLevel="nothing"
        summaryChildren={
          <>
            <PlanSelector
              mode="multiple"
              id={subPlan.id}
              isSelected={isSelected}
              handleChange={handleChange}
            />
            {getSummary(subPlan)}
          </>
        }
        summaryTrailing={<PlanValidationIcon formikKeyPrefix={formikKeyPrefix} />}
      >
        <BuilderTransferSourceForm
          pot={subPlan}
          id={subPlan.id}
          index={0}
          maxAmount={getCurrencyFloat(subPlan.totalValue)}
        />
      </PlanAccordionShell>
    </PlanRow>
  );
};
